import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-560ac39d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivers" }
const _hoisted_2 = { class: "d-flex align-items-xl-center justify-content-between flex-xl-row flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "receiver-heading me-xl-4",
  "data-test": "receivers-list-heading"
}, "Receiver Inventory", -1))
const _hoisted_4 = { class: "order-2 order-xl-1 flex-grow-1 mt-5 mt-xl-0" }
const _hoisted_5 = { class: "order-1 order-xl-2 ms-auto ms-xl-2 d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "onboarding__target onboarding__target--top-left"
}
const _hoisted_7 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("When you create "),
  /*#__PURE__*/_createElementVNode("strong", null, "receivers"),
  /*#__PURE__*/_createTextVNode(" they will appear here in your "),
  /*#__PURE__*/_createElementVNode("strong", null, "receiver inventory"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "text-center my-5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { "data-test": "no-receivers-added-heading" }, "You haven't added any receivers yet.", -1))
const _hoisted_11 = { class: "inventory-table__actions d-flex flex-column flex-sm-row align-items-sm-end mb-4" }
const _hoisted_12 = { class: "order-3 order-sm-0 mt-4 mt-sm-0" }
const _hoisted_13 = { class: "mx-sm-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "small",
  "data-test": "receivers-filter-text"
}, "Filter Receivers By:", -1))
const _hoisted_15 = { class: "ms-sm-auto mt-4 mt-sm-0" }
const _hoisted_16 = { class: "px-1" }
const _hoisted_17 = { class: "d-flex flex-row mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receivers-platform-table-heading"
}, "Receiver Platform: ", -1))
const _hoisted_19 = { class: "expanded-table__description" }
const _hoisted_20 = { class: "d-flex flex-row mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receivers-version-table-heading"
}, "Version: ", -1))
const _hoisted_22 = { class: "expanded-table__description" }
const _hoisted_23 = { class: "d-flex flex-row mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receivers-status-table-heading"
}, "Status: ", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_31 = ["d"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "d-flex flex-row mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receivers-room-table-heading"
}, "Room: ", -1))
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "d-flex flex-row mb-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receviers-location-table-heading"
}, "Location: ", -1))
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "d-flex flex-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "expanded-table__heading",
  "data-test": "receivers-sublocation-table-heading"
}, "Sublocation: ", -1))
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_43 = ["d"]
const _hoisted_44 = { class: "px-1" }
const _hoisted_45 = { class: "d-flex flex-row mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Receiver Platform: ", -1))
const _hoisted_47 = { class: "expanded-table__description" }
const _hoisted_48 = { class: "d-flex flex-row mb-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Version: ", -1))
const _hoisted_50 = { class: "expanded-table__description" }
const _hoisted_51 = { class: "d-flex flex-row mb-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Room: ", -1))
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "d-flex flex-row mb-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Location: ", -1))
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { class: "d-flex flex-row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Sublocation: ", -1))
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24"
}
const _hoisted_61 = ["d"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-name-table-heading"
}, "Name", -1))
const _hoisted_63 = { class: "d-flex" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-platform-table-heading"
}, "Platform", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-version-table-heading"
}, "Version", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-status-table-heading"
}, "Status", -1))
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "receiver-status__popover-link",
  target: "_blank",
  rel: "noreferrer noopener",
  href: "https://help.airsquirrels.com/ditto/413-determining-your-receivers-status"
}, " Click here to learn more. ", -1))
const _hoisted_71 = { key: 0 }
const _hoisted_72 = {
  key: 1,
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_73 = ["d"]
const _hoisted_74 = { key: 1 }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-room-table-heading"
}, "Room", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-location-table-heading"
}, "Location", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell",
  "data-test": "receivers-sublocation-table-heading"
}, "Sublocation", -1))
const _hoisted_78 = {
  class: "text-truncate",
  style: {"display":"inline-block","max-width":"100%","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_79 = {
  class: "icon--small icon--white",
  viewBox: "0 0 24 24",
  "data-test": "receivers-delete-table-button-icon"
}
const _hoisted_80 = ["d"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubscriptionStatusProgress = _resolveComponent("SubscriptionStatusProgress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SubscriptionStatusProgress, { class: "subscription-status" })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          ref: "newReceiverButton",
          class: _normalizeClass({ 'onboarding__above-overlay' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }),
          type: "primary",
          onClick: _ctx.onCreate,
          "data-test": "new-receiver-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" New Receiver "),
            (_ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "onClick"])
      ])
    ]),
    (!_ctx.canActivateReceivers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_popover, {
      trigger: "manual",
      placement: "top-start",
      "popper-class": "onboarding__popover",
      width: 300,
      disabled: !_ctx.userOnboardStatus.value.isOnboarding || !_ctx.domLoaded,
      visible: _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog &&  _ctx.currentStep.value.banner
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-container", { 'onboarding__above-overlay onboarding__inventory el-overlay--prevent-clicking' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }])
        }, [
          (!_ctx.loading && _ctx.allReceivers.length == 0 && !_ctx.filterEnabled && !_ctx.searchDebounce)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_button, {
                  class: _normalizeClass(["px-5 py-3", { 'el-overlay--allow-clicks' : _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }]),
                  type: "primary",
                  onClick: _ctx.onCreate,
                  "data-test": "add-first-receiver-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add Your First Receiver ")
                  ]),
                  _: 1
                }, 8, ["class", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.selectedReceiverIds.length > 0,
                      content: "Select receivers to unlink.",
                      "close-delay": "0",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(["m-0 me-2", { 'is-disabled' : _ctx.selectedReceiverIds.length < 1 }]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleUnlink())),
                          "data-test": "unlink-receivers-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Unlink Receivers")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.selectedReceiverIds.length > 0,
                      content: "Select receivers to delete.",
                      "close-delay": "0",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: _normalizeClass(["m-0", { 'is-disabled' : _ctx.selectedReceiverIds.length < 1 }]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.massDeleteReceivers())),
                          "data-test": "delete-receivers-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Delete")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.receiverPlatformFilter,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.receiverPlatformFilter) = $event)),
                      placeholder: "Receiver Platform",
                      onChange: _ctx.handleFilterChange,
                      clearable: "",
                      "data-test": "receivers-filter-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("All Receivers")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiverPlatforms, (type) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            value: type.value,
                            key: type.value,
                            label: type.display
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(type.display), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_input, {
                      placeholder: "Search Receivers",
                      modelValue: _ctx.receiverSearch,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receiverSearch) = $event)),
                      onKeyup: _ctx.handleFilterChange,
                      "data-test": "receivers-search-input"
                    }, null, 8, ["modelValue", "onKeyup"])
                  ])
                ]),
                (_openBlock(), _createBlock(_component_el_table, {
                  class: "inventory-table",
                  data: _ctx.allReceiversDisplay,
                  ref: "multipleTable",
                  onCellClick: _ctx.handleCurrentChange,
                  onSelectionChange: _ctx.handleSelectionChange,
                  onSortChange: _ctx.sortTable,
                  "data-test": "receivers-list-table",
                  "default-sort": _ctx.defaultSort,
                  key: _ctx.defaultSortKey
                }, {
                  default: _withCtx(() => [
                    (_ctx.windowWidth.value < 576)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          type: "expand",
                          width: "55"
                        }, {
                          default: _withCtx((props) => [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("div", _hoisted_19, _toDisplayString(props.row.platform), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("div", _hoisted_22, _toDisplayString(props.row.lastKnownVersion), 1)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                (props.row.room && props.row.room._id && props.row.status !== undefined && props.row.status !== null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createVNode(_component_el_popover, {
                                        "popper-class": "is-dark",
                                        trigger: "click",
                                        placement: "top-start",
                                        width: 300
                                      }, {
                                        reference: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.receiverStatus(props.row.status).toLowerCase()}`)
                                          }, [
                                            (_ctx.receiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.receiverStatus(props.row.status)), 1))
                                              : (_openBlock(), _createElementBlock("svg", _hoisted_30, [
                                                  _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_31)
                                                ]))
                                          ], 2)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, [
                                            (_ctx.receiverStatus(props.row.status).toLowerCase() != 'legacy')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Receiver status is " + _toDisplayString(_ctx.receiverStatus(props.row.status).toLowerCase()) + ". ", 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_27, "Legacy receivers do not support receiver status. ")),
                                            _hoisted_28
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, "-"))
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                (props.row.room._id)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/rooms/${props.row.room._id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.room.roomName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_35, "-"))
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                (props.row.location && props.row.location.parentId)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.parentId}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.location.parentName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (props.row.location)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 1,
                                        class: "expanded-table__description",
                                        to: `/locations/${props.row.location.id}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_38, "-"))
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                (props.row.subLocation && props.row.location)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: "expanded-table__description",
                                      to: `/locations/${props.row.location.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.row.subLocation), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_41, "-"))
                              ]),
                              _createVNode(_component_el_button, {
                                class: "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile",
                                type: "danger",
                                onClick: _withModifiers(($event: any) => (_ctx.handleDelete(props.row)), ["stop"]),
                                circle: "",
                                "data-test": "receivers-delete-table-button"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_42, [
                                    _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_43)
                                  ]))
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 1
                        }))
                      : (_ctx.windowWidth.value >= 576 && _ctx.windowWidth.value < 992)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            type: "expand",
                            width: "55"
                          }, {
                            default: _withCtx((props) => [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _hoisted_46,
                                  _createElementVNode("div", _hoisted_47, _toDisplayString(props.row.platform), 1)
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _hoisted_49,
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(props.row.lastKnownVersion), 1)
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _hoisted_52,
                                  (props.row.room._id)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "expanded-table__description",
                                        to: `/rooms/${props.row.room._id}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.room.roomName), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_53, "-"))
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _hoisted_55,
                                  (props.row.location && props.row.location.parentId)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "expanded-table__description",
                                        to: `/locations/${props.row.location.parentId}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.location.parentName), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (props.row.location)
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 1,
                                          class: "expanded-table__description",
                                          to: `/locations/${props.row.location.id}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.row.location.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_56, "-"))
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _hoisted_58,
                                  (props.row.subLocation && props.row.location)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "expanded-table__description",
                                        to: `/locations/${props.row.location.id}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(props.row.subLocation), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_59, "-"))
                                ]),
                                _createVNode(_component_el_button, {
                                  class: "mt-4 mb-3 el-table-row__delete-button el-table-row__delete-button--mobile",
                                  type: "danger",
                                  onClick: _withModifiers(($event: any) => (_ctx.handleDelete(props.row)), ["stop"]),
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_60, [
                                      _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_61)
                                    ]))
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "displayName",
                      label: "Name",
                      sortable: "custom",
                      "data-test": "receivers-name-table-heading"
                    }, {
                      header: _withCtx(() => [
                        _hoisted_62
                      ]),
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_63, [
                          _createVNode(_component_router_link, {
                            class: "el-table-column__name me-2 me-sm-0",
                            to: `/receivers/${scope.row.id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (_ctx.windowWidth.value < 576 && scope.row.roomId)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(`ms-auto align-self-center receiver-status__badge__mobile receiver-status__badge__mobile--${_ctx.receiverStatus(scope.row.status, scope.row.deviceType).toLowerCase()}`),
                                "aria-hidden": "true"
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 2,
                          prop: "platform",
                          label: "Platform",
                          sortable: "custom",
                          "data-test": "receivers-platform-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_64
                          ]),
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.platform) + " (" + _toDisplayString(scope.row.deviceType) + ") ", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 3,
                          prop: "lastKnownVersion",
                          label: "Version",
                          sortable: "custom",
                          "data-test": "receivers-version-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_65
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 576)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 4,
                          prop: "status",
                          label: "Status",
                          sortable: "custom",
                          "data-test": "receivers-status-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_66
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.room && scope.row.room._id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                  _createVNode(_component_el_popover, {
                                    "popper-class": "is-dark",
                                    trigger: "hover",
                                    placement: "top-start",
                                    width: 300
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(`receiver-status__badge receiver-status__badge--${_ctx.receiverStatus(scope.row.status).toLowerCase()}`)
                                      }, [
                                        (_ctx.receiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.receiverStatus(scope.row.status)), 1))
                                          : (_openBlock(), _createElementBlock("svg", _hoisted_72, [
                                              _createElementVNode("path", { d: _ctx.mdiHelp }, null, 8, _hoisted_73)
                                            ]))
                                      ], 2)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, [
                                        (_ctx.receiverStatus(scope.row.status).toLowerCase() != 'legacy')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Receiver status is " + _toDisplayString(_ctx.receiverStatus(scope.row.status).toLowerCase()) + ". ", 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_69, "Legacy receivers do not support receiver status. ")),
                                        _hoisted_70
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_74, "-"))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 5,
                          prop: "room.roomName",
                          label: "Room",
                          sortable: "custom",
                          "data-test": "receivers-room-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_75
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.room && scope.row.room._id)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/rooms/${scope.row.room._id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.room.roomName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 6,
                          prop: "lowercaseLocation, id",
                          label: "Location",
                          sortable: "custom",
                          "data-test": "receivers-location-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_76
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.location && scope.row.location.parentId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/locations/${scope.row.location.parentId}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.location.parentName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (scope.row.location)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: `/locations/${scope.row.location.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row.location.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode("-")
                                  ], 64))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 7,
                          prop: "location.parentName",
                          label: "Sublocation",
                          sortable: "custom",
                          "data-test": "receivers-sublocation-table-heading"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_77
                          ]),
                          default: _withCtx((scope) => [
                            (scope.row.subLocation)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: `/locations/${scope.row.location.id}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row.subLocation), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("-")
                                ], 64))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 576)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 8,
                          prop: "note",
                          label: "Note",
                          sortable: "custom"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_tooltip, {
                              placement: "top-start",
                              title: "",
                              width: 300
                            }, {
                              content: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["custom-scroll", { 'long-content': scope.row.note && scope.row.note.length > 400 }])
                                }, _toDisplayString(scope.row.note), 3)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_78, _toDisplayString(scope.row.note), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.windowWidth.value >= 992)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 9,
                          prop: "id",
                          "class-name": "el-table-row__delete"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              class: "el-table-row__delete-button",
                              type: "danger",
                              id: scope.row.id,
                              onClick: _withModifiers(($event: any) => (_ctx.handleDelete(scope.row)), ["stop"]),
                              circle: "",
                              "data-test": "receivers-delete-table-button"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("svg", _hoisted_79, [
                                  _createElementVNode("path", { d: _ctx.mdiDelete }, null, 8, _hoisted_80)
                                ]))
                              ]),
                              _: 2
                            }, 1032, ["id", "onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data", "onCellClick", "onSelectionChange", "onSortChange", "default-sort"])),
                _hoisted_81,
                _createVNode(_component_el_pagination, {
                  class: "d-flex justify-content-center",
                  background: "",
                  layout: "prev, pager, next, slot",
                  total: _ctx.receiverCount,
                  "page-size": _ctx.paging.pageSize,
                  onCurrentChange: _ctx.handleCurrentPageChange,
                  onSizeChange: _ctx.handleSizeChange,
                  "current-page": _ctx.paging.pageIndex,
                  "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.pageIndex) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_select, {
                        onChange: _ctx.handleSizeChange,
                        "model-value": _ctx.paging.pageSize,
                        size: "small",
                        "data-test": "receivers-pagination-dropdown"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "10 per page",
                            value: 10
                          }),
                          _createVNode(_component_el_option, {
                            label: "50 per page",
                            value: 50
                          }),
                          _createVNode(_component_el_option, {
                            label: "100 per page",
                            value: 100
                          }),
                          _createVNode(_component_el_option, {
                            label: "500 per page",
                            value: 500
                          }),
                          _createVNode(_component_el_option, {
                            label: "All",
                            value: 100000
                          })
                        ]),
                        _: 1
                      }, 8, ["onChange", "model-value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["total", "page-size", "onCurrentChange", "onSizeChange", "current-page"])
              ], 64))
        ], 2)
      ]),
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["disabled", "visible"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}